import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-new-cliente',
  templateUrl: './new-cliente.component.html',
  styleUrls: ['./new-cliente.component.scss']
})
export class NewClienteComponent {
  @Input() buttonOnlyIcon: boolean = false;
  clienteForm: FormGroup;
  @Output() updateData = new EventEmitter();
  regiones: Array<any> = []
  provincias: Array<any> = []
  comunas: Array<any> = []

  constructor(private modalService: NgbModal,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public generalService: GeneralService,
    private loadingService: LoadingService) { }

  async ngOnInit() {
    await this.initializeForm();
  }

  async initializeForm() {
    await this.getComunas();
    this.clienteForm = this.fb.group({
      nombre: [null, Validators.required],
      apellido: [null, Validators.required],
      email: [null],
      telefono: [null],
      direccion: [null],
      comuna_id: [null],
      comuna_nombre: [null],
      detalle: [null],
    });
  }

  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      this.loadingService.setLoading(true)
      if (result.direccion && result.comuna_id == null) {
        this.loadingService.setLoading(false)
        this.toastr.error('Debe indicar una comuna!')
        return
      }
      //Cerrado/guardado retornando objeto
      this.generalService
        .postCrear("cliente", {
          "nombre": result.nombre,
          "apellido": result.apellido,
          "email": result.email,
          "telefono": result.telefono,
          "habilitado": true
        })
        .then(async res => {
          if (result.direccion) {
            let geocode = await this.generalService.getListar(`geo-utils/geocode?address=${result.direccion},${result.comuna_nombre},${result.provincia_nombre},${result.region_nombre}`)
            this.generalService
              .postCrear("direccion", {
                "id_cliente": res.data.id_cliente,
                "direccion": result.direccion,
                "comuna_id": result.comuna_id,
                "detalle": result.detalle,
                "latitud": geocode.data.lat ? geocode.data.lat : null,
                "longitud": geocode.data.lng ? geocode.data.lng : null
              })
          }
          else {
            this.toastr.success('Cliente creado exitosamente!');
            this.loadingService.setLoading(false)
            this.initializeForm();
            this.updateData.emit();
          }
        })
        .then(res => {
          this.toastr.success('Cliente creado exitosamente!');
          this.loadingService.setLoading(false)
          this.initializeForm();
          this.updateData.emit();
        })
        .catch(err => {
          this.toastr.error('Error al actualizar!')
          this.loadingService.setLoading(false)
        });
    }, (reason) => {
      this.loadingService.setLoading(false)
      //Cerrasdo por X, ESC, backdrop
    });
  }

  async getComunas() {
    try {
      this.loadingService.setLoading(true)
      let res = await this.generalService.getListar("comunas")
      this.comunas = res.data;
      this.loadingService.setLoading(false)
    } catch (error) {
      this.comunas = [];
      this.loadingService.setLoading(false)
    }
  }

  onSelectItemComuna(item) {
    if(item == null)
    {
      this.clienteForm.get('comuna_id').setValue(null);
      return
    }
    this.clienteForm.get('comuna_id').setValue(item.comuna_id);
  }

}
